export default {
  unapprovedSwapShifts: [],
  confirmedSwapShifts: [],
};
